
const state = {
	activecategory : undefined,
	activesubcategory : undefined,
	activesubofsubcategory : undefined
};

// getters
// const getters = {

// }

// mutations
const mutations = {
};

// actions
const actions = {
};

export default {
	namespaced: true,
	state,
	// getters,
	actions,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/common.js